import { Role } from "../../types/interfaces/account";

const getRoleIdFromType = (
  type: string,
  roles: Role[] | undefined
): number | undefined => {
  if (!roles || roles.length === 0) return undefined;
  const targetRole = roles.find((role) => {
    return role.type.toLowerCase() === type.toLowerCase();
  });
  return targetRole ? targetRole.id : undefined;
};

export { getRoleIdFromType };
